function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { forwardRef } from 'react';
import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { Box } from '../../../Box';
import { useCalendarContext } from '../../CalendarContext';
import { useWeekDays } from './useWeekDays';
import { jsx as _jsx } from "react/jsx-runtime";
export var WeekDaysHeader = /*#__PURE__*/forwardRef((props, ref) => {
  var {
    size,
    isMobileDatePicker
  } = useCalendarContext();
  var styles = useMultiStyleConfig('_BaseCalendar', {
    isMobileDatePicker,
    size
  });
  var weekDays = useWeekDays();
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    role: "row",
    __css: styles['calendarRow']
  }, props), {}, {
    ref: ref,
    children: weekDays.map(weekDay => /*#__PURE__*/_jsx(Box, {
      role: "columnheader",
      __css: styles['headerCell'],
      "aria-label": weekDay.fullLabel,
      children: weekDay.label
    }, weekDay.label))
  }));
});
//# sourceMappingURL=WeekDaysHeader.js.map